import(/* webpackMode: "eager" */ "/Users/arielmuslera/code/otto-the-butler/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryInit"] */ "/Users/arielmuslera/code/otto-the-butler/web/app/sentry-provider.tsx");
